import { useTLang } from 'intl/intl';
import type { ChipMode } from '../SFStockoutItemChip.const';

const LANG_ID_BY_MODE: Record<ChipMode, string> = {
  stockout: 'substitutionFlow.003',
  replacement: 'substitutionFlow.025',
  options: 'substitutionFlow.039',
};

export function useSFStockoutItemChip(props: Props) {
  const { mode } = props;

  const lang = {
    label: useTLang({
      id: LANG_ID_BY_MODE[mode],
    }),
  };

  return {
    lang,
  };
}

interface Props {
  mode: ChipMode;
}
